const isDateBetween = (startDate, endDate, targetDate) => {
  startDate = new Date(startDate).setHours(0, 0, 0, 0);
  endDate = new Date(endDate).setHours(0, 0, 0, 0);
  targetDate = new Date(targetDate).setHours(0, 0, 0, 0);
  return startDate <= targetDate && targetDate <= endDate;
};

export default isDateBetween;
